// extracted by mini-css-extract-plugin
export var avatarContainer = "_5m-0";
export var avatarTypingWave = "_5m-i";
export var gray = "_5m-f";
export var green = "_5m-c";
export var icon = "_5m-9";
export var image = "_5m-1";
export var lg = "_5m-6";
export var md = "_5m-5";
export var presenceDot = "_5m-b";
export var red = "_5m-d";
export var sm = "_5m-4";
export var status = "_5m-a";
export var typingDot = "_5m-h";
export var typingPill = "_5m-g";
export var xl = "_5m-7";
export var xs = "_5m-3";
export var xxl = "_5m-8";
export var xxs = "_5m-2";
export var yellow = "_5m-e";